import { ReactNode } from 'react';

export enum confirmModalTypes {
  closeModal = 'closeModal',
  firstChoiceAction = 'firstChoiceAction',
  secondChoiceAction = 'secondChoiceAction'
}

export interface IConfirmModal {
  show: boolean;
  description: string | ReactNode;
  onAction: (type: confirmModalTypes) => void;
  title?: string;
  secondChoice?: string;
  firstChoice?: string;
  shouldCloseOnOverlayClick?: boolean;
  showCloseIcon?: boolean;
  showUpgradeIcon?: boolean;
  showTickIcon?: boolean;
  hideFirstChoice?: boolean;
  isPremiumButton?: boolean;
  isDisabledSecondChoice?: boolean;
}
